<template>
    <Head title="Réinitialisez votre mot de passe" />

    <AuthLayout title="Réinitialisation de mot de passe">
        <JetValidationErrors class="mb-4" />

        <form @submit.prevent="submit">
            <div>
                <JetLabel for="email" value="Adresse mail" />
                <JetInput id="email" type="email" placeholder="Entrer votre adresse mail"
                    v-model="form.email" required autofocus
                />
            </div>

            <div class="mt-4">
                <JetLabel for="password" value="Mot de passe" />
                <JetInput id="password" type="password"
                    v-model="form.password" required autocomplete="new-password"
                    placeholder="Entrer votre nouveau mot de passe"
                />
            </div>

            <div class="mt-4">
                <JetLabel for="password_confirmation" value="Confirmer mot de passe" />
                <JetInput id="password_confirmation" type="password"
                    v-model="form.password_confirmation" required autocomplete="new-password"
                    placeholder="Confirmer votre nouveau mot de passe"
                />
            </div>

            <div class="flex items-center justify-end mt-4">
                <BotiButton :loader="form.processing" :disabled="form.processing"
                    @click="submit"  color="greendack"
                    :class="{ 'opacity-25': form.processing }" text="Réinitialiser"
                >
                    <svg v-if="form.processing" class="animate-spin w-4 h-4 fill-current shrink-0" viewBox="0 0 16 16">
                        <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z"></path>
                    </svg>
                    <template #icon>
                        <i class="fad fa-check-circle text-xs ml-1"></i>
                    </template>
                </BotiButton>
            </div>
        </form>
    </AuthLayout>
</template>

<script>
    import { defineComponent } from 'vue';
    import JetInput from '@/Jetstream/Input.vue'
    import JetLabel from '@/Jetstream/Label.vue'
    import BotiButton from '@/Components/Button'
    import JetButton from '@/Jetstream/Button.vue'
    import { Head } from '@inertiajs/inertia-vue3';
    import AuthLayout from '@/Layouts/AuthLayout.vue'
    import JetValidationErrors from '@/Jetstream/ValidationErrors.vue'

    export default defineComponent({
        components: {
            Head,
            JetInput,
            JetLabel,
            JetButton,
            AuthLayout,
            BotiButton,
            JetValidationErrors
        },

        props: {
            email: String,
            token: String
        },

        data() {
            return {
                form: this.$inertia.form({
                    token: this.token,
                    email: this.email,
                    password: '',
                    password_confirmation: ''
                })
            }
        },

        methods: {
            submit() {
                this.form.post(this.route('password.update'), {
                    onFinish: () => this.form.reset('password', 'password_confirmation')
                })
            }
        }
    })
</script>
